
import React from 'react';
import { TabsList, TabsTrigger } from "@/components/ui/tabs";

interface QuoteTabsListProps {
  currentQuotesCount: number;
  declinedQuotesCount: number;
  allQuotesCount: number;
  isAdmin: boolean;
}

const QuoteTabsList = ({
  currentQuotesCount,
  declinedQuotesCount,
  allQuotesCount,
  isAdmin
}: QuoteTabsListProps) => {
  return (
    <div className="relative border-b border-border">
      <TabsList className={`grid w-full ${isAdmin ? 'grid-cols-4' : 'grid-cols-3'}`}>
        <TabsTrigger value="current" className="px-4 text-xs h-10">
          Current Quotes ({currentQuotesCount})
        </TabsTrigger>
        <TabsTrigger value="declined" className="px-4 text-xs h-10">
          Declined ({declinedQuotesCount})
        </TabsTrigger>
        <TabsTrigger value="history" className="px-4 text-xs h-10">
          All History ({allQuotesCount})
        </TabsTrigger>
        {isAdmin && (
          <TabsTrigger value="new-quote" className="px-4 text-xs h-10">
            New Quote
          </TabsTrigger>
        )}
      </TabsList>
    </div>
  );
};

export default QuoteTabsList;
